import { AgTechDataActionLoggingContext } from "../data/actions/AgTechDataActions";
import { isDev } from "../utilities/AgTechUtilities";

export const logDev = (message: any, ...details: any[]) => {
    if (true) {
        console.log(message, ...details);
    }
}

export const logDevError = (message: any, ...details: any[]) => {
    if (true) {
        console.error(message, ...details);
    }
}

export const logEntry = (source: string, message: string, details?: any) => {
    logDev(`[${source}]: ${message}`, details);
}

export const logEntryError = (source: string, message: string, details?: any) => {
    logDevError(`[${source}]: ${message}`, details);
}

export const logEvent = (name: string, data: any) => {
    logDev({
        event: name,
        ...data
    });
}

export const logAction = (actionData: AgTechDataActionLoggingContext<any, any>) => {
    if (actionData.execution.result.wasActionSuccessful) {
        logEntry('Action Successful', actionData.name, actionData);
    }
    else {
        logEntryError('Action Failed', actionData.name, actionData);
    }
}